<div class="pagination flex items-center" *ngIf="info ">
	<div class="back" (click)="fullBack()" [ngClass]="{ 'cursor-pointer	': info.pages || 0 > 1 }">
		<img src="../../../../assets/icon/full-back-icon.svg" alt="full-back" />
	</div>
	<div class="back" (click)="back()" [ngClass]="{ 'cursor-pointer	': info.pages || 0 > 1 }">
		<img src="../../../../assets/icon/back-icon.svg" alt="full-back" />
	</div>
	<span class="font-lato ml-4 mr-4 text-base">
		{{ info.page || 0 }} - {{ info.pageTo || 0 }} {{ textTo }}
		{{ info.total || 0 }}
	</span>
	<div class="back" (click)="next()" [ngClass]="{ 'cursor-pointer	': info.pages || 0 > 1 }">
		<img src="../../../../assets/icon/back-icon.svg" class="rotate-icon" alt="full-back" />
	</div>
	<div class="back" (click)="fullNext()" [ngClass]="{ 'cursor-pointer	': info.pages || 0 > 1 }">
		<img src="../../../../assets/icon/full-back-icon.svg" class="rotate-icon" alt="full-back" />
	</div>
</div>
